import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.screens.selecaoEnvioCodigoPrimeiroAcesso.background,
    alignItems: 'center',
  },

  containerGrid: {
    height: '544px',
    maxWidth: '430px',
    backgroundColor: theme.screens.selecaoEnvioCodigoPrimeiroAcesso.cardBackground,
    padding: '60px 56px 73px',
    borderRadius: '8px',
    margin: '47px 0 139px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      margin: 0,
      padding: '37px 21px 40px',
      borderRadius: '0px',
    },
  },

  link: {
    fontSize: '14px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.63',
    letterSpacing: 'normal',
    textAlign: 'left',
    textDecoration: 'underline',
    color: theme.appColors.primaryColor,
    fontFamily: 'Inter',
    '&:hover': {
      filter: 'brightness(80%)',
    },
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      fontWeight: 700,
    },
  },

  titulo: {
    fontFamily: theme.typography.bancoDoBrasilTitulos.fontFamily,
    color: theme.screens.selecaoEnvioCodigoPrimeiroAcesso.title,
    fontSize: 24,
    textAlign: 'left',
    fontWeight: 500,
  },
  subTitulo: {
    color: theme.screens.selecaoEnvioCodigoPrimeiroAcesso.subtitle,
    fontFamily: theme.typography.inter.fontFamily,
    fontSize: 14,
    letterSpacing: -0.01,
    textAlign: 'left',
    lineHeight: '24px',
  },

  button: {
    color: '#FFFFFF',
    fontFamily: 'BancoDoBrasilTitulos',
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.66px',
    textAlign: 'center',
    marginTop: theme.spacing(1),
    width: 200,
    height: '48px',
    marginBottom: 20,
    textTransform: 'uppercase',
    [theme.breakpoints.down('xs')]: {
      width: '90vw',
    },
  },
  input: {
    margin: '32px 0 38px',
  },
}));
